function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M41.827 263.633c0 5.833 4.73 10.563 10.563 10.563s10.563-4.73 10.563-10.563-4.73-10.563-10.563-10.563c-5.834 0-10.563 4.73-10.563 10.563M4.408 126.572h53.148V73.424H4.408zm256.678 137.705c0 5.513 4.469 9.982 9.98 9.982 5.515 0 9.984-4.47 9.984-9.982 0-5.513-4.47-9.981-9.983-9.981-5.512 0-9.981 4.468-9.981 9.98",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M207.19 267.954c2.367 35.457 31.876 63.483 67.933 63.483 37.603 0 68.087-30.483 68.087-68.086 0-36.281-28.378-65.934-64.148-67.974m-10.202.172c-33.447 3.05-59.902 30.29-61.724 64.077m14.554-.573c2.036-25.544 22.06-46.1 47.364-48.965",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M279.951 209.963c27.303 2.448 48.772 25.458 48.772 53.388 0 29.556-24.043 53.6-53.6 53.6-27.696 0-50.556-21.113-53.322-48.092m92.473 51.188l36.442 36.442c3.885 3.885 10.184 3.885 14.07 0 3.884-3.885 3.884-10.183 0-14.068l-36.045-36.043",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M264.924 263.487c0 5.507 4.464 9.972 9.972 9.972 5.507 0 9.97-4.465 9.97-9.972s-4.463-9.972-9.97-9.972c-5.508 0-9.972 4.465-9.972 9.972zm-19.39 14.542v15.373h15.373m0-61.492h-15.373v15.373m61.492 0V231.91h-15.373m0 61.492h15.373v-15.373",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M259.862 84.105c0 6.386 5.177 11.562 11.562 11.562s11.562-5.176 11.562-11.562c0-6.385-5.177-11.562-11.562-11.562s-11.562 5.177-11.562 11.562",
  fill: "#FFF"
}), React.createElement("path", {
  stroke: "#28348A",
  strokeWidth: 0.75,
  d: "M10.432 126.572h53.147V73.424H10.432zM86.57 83.977h110.791M86.57 98.66h85.378M86.57 113.343h103.45M1.375 251.431c0 5.833 4.729 10.563 10.563 10.563 5.833 0 10.562-4.73 10.562-10.563s-4.729-10.563-10.562-10.563c-5.834 0-10.563 4.73-10.563 10.563zm44.597 12.202c0 5.833 4.729 10.563 10.563 10.563 5.833 0 10.562-4.73 10.562-10.563s-4.73-10.563-10.562-10.563c-5.834 0-10.563 4.73-10.563 10.563zm64.184-69.785c0 5.833 4.73 10.563 10.563 10.563s10.562-4.73 10.562-10.563c0-5.834-4.729-10.563-10.562-10.563-5.834 0-10.563 4.73-10.563 10.563zm44.992 7.986c0 5.833 4.728 10.563 10.563 10.563 5.832 0 10.561-4.73 10.561-10.563s-4.728-10.563-10.561-10.563c-5.835 0-10.564 4.73-10.564 10.563zM286.297 83.683c0-5.833-4.73-10.563-10.563-10.563s-10.562 4.73-10.562 10.563 4.729 10.563 10.562 10.563c5.834 0 10.563-4.73 10.563-10.563m64.758-61.745c0-5.833-4.73-10.563-10.563-10.563s-10.562 4.73-10.562 10.563c0 5.832 4.729 10.563 10.562 10.563 5.834 0 10.563-4.73 10.563-10.563M21.326 255.906l24.646 5.28m19.586-3.3l46.604-57.795m18.924-4.181l23.986 4.62M269.45 92.709l-96.554 101.44"
}), React.createElement("path", {
  d: "M274.45 95.477V252.56",
  stroke: "#28348A",
  strokeWidth: 0.75,
  strokeDasharray: "2,5,2,5,2,5"
}), React.createElement("path", {
  d: "M51.513 85.484l-27.82 27.82m-.001-27.82l27.82 27.82M284.52 78.243l48.192-50.45M52.223 259.338l8.895 8.895m-8.895-.001l8.895-8.895M271.72 78.902l8.895 8.895m-8.895 0l8.895-8.895m-9.555 179.871l8.895 8.895m-8.895-.001l8.895-8.895",
  stroke: "#28348A",
  strokeWidth: 0.75
}), React.createElement("path", {
  d: "M67.097 263.633h196.622",
  stroke: "#28348A",
  strokeWidth: 0.75,
  strokeDasharray: "2,5,2,5,2,5"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 370 370",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/steps/slides/slide_8.svg